import successIcon from './success.svg'
const IconSuccss = () => {
  return (
        <>
            <img src={successIcon} width="16px"/>
        </>
  )
}

export default IconSuccss
